import { isNotDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const TotalLeverage = () => {
  const tileId = useForwardAccumulatorTileId();

  const totalLeverage = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'totalLeverage'));
  if (isNotDefined(totalLeverage)) {
    return null;
  }

  return (
    <span className="form-control-plaintext p-0 text-end fs-12" data-e2e="total-leverage">
      <FormattedNumber value={totalLeverage} />
    </span>
  );
};

export default TotalLeverage;
